import { useFormik } from "formik";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Loader from "../../../Shared/Loader";
import { apiConnectorGet, apiConnectorPost } from "../../../utils/APIConnector";
import { endpoint } from "../../../utils/APIRoutes";
import { areYouSureFn } from "../../../utils/utilityFun";
import logo from "../../../assets/logo.png";

function TopupWithContWithoutPull() {
  const [qrCode, setQrCode] = useState("");
  const navigate = useNavigate();

  useEffect(() => { window.scrollTo(0, 0); }, []);

  const [loding, setLoding] = useState(false);
  const fk = useFormik({ initialValues: { inr_value: "" } });

  async function generateDepositQrCode() {
    setLoding(true);
    try {
      if (!fk.values.inr_value || Number(fk.values.inr_value || 0) <= 0) {
        Swal.fire({ text: "Please enter amount first", confirmButtonColor: "#2563EB" });
        setLoding(false);
        return;
      }
      const res = await apiConnectorPost(endpoint?.get_topup_qr, {
        pkg_amount: fk.values.inr_value,
      });
      if (res?.data?.success) {
        setQrCode(res?.data?.result?.[0]);
      } else {
        toast("Failed to fetch QR code.");
      }
    } catch (error) {
      toast("Error connecting...");
    }
    setLoding(false);
  }

  async function sendTokenTransaction() {
    setLoding(true);
    try {
      const apiRes = await apiConnectorGet(endpoint?.member_self_topup);
      if (apiRes?.data?.success) {
        Swal.fire({ icon: "success", text: apiRes?.data?.msg, confirmButtonColor: "#2563EB" });
        navigate("/activation");
      } else {
        Swal.fire({ icon: "warning", text: apiRes?.data?.msg || "Topup failed.", confirmButtonColor: "#2563EB" });
      }
    } catch (error) {
      toast("Error connecting...");
    }
    setLoding(false);
  }

  const { data: profile_data } = useQuery(
    ["profile_api"],
    () => apiConnectorGet(endpoint?.profile_api),
    { refetchOnMount: false, refetchOnReconnect: false, retry: false, retryOnMount: false, refetchOnWindowFocus: false }
  );
  const user_profile = profile_data?.data?.result?.[0] || {};

  return (
    <>
      <Loader isLoading={loding} />

      <div className="min-h-screen flex items-center justify-center px-4 py-10 relative overflow-hidden bg-gradient-to-br from-[#060E1C] via-[#080F1C] to-[#060E1C]">
        {/* Background effects */}
        <div className="pointer-events-none fixed inset-0 bg-[radial-gradient(circle_at_50%_20%,rgba(37,99,235,0.12),transparent_60%)]" />
        <div className="pointer-events-none fixed inset-0" style={{ backgroundImage: `linear-gradient(rgba(37,99,235,0.06) 1px,transparent 1px),linear-gradient(90deg,rgba(37,99,235,0.06) 1px,transparent 1px)`, backgroundSize: "40px 40px" }} />
        <div className="pointer-events-none fixed top-0 left-0 w-80 h-80 bg-[#2563EB]/8 rounded-full blur-3xl animate-pulse" />
        <div className="pointer-events-none fixed bottom-0 right-0 w-80 h-80 bg-[#1D4ED8]/8 rounded-full blur-3xl animate-pulse" style={{ animationDelay: "1.5s" }} />

        {/* Floating particles */}
        <div className="fixed top-24 left-16 w-1.5 h-1.5 bg-[#2563EB] rounded-full opacity-50 animate-ping" />
        <div className="fixed bottom-32 right-24 w-1.5 h-1.5 bg-[#22D3EE] rounded-full opacity-50 animate-ping" style={{ animationDelay: "1.2s" }} />
        <div className="fixed top-1/2 left-1/4 w-1 h-1 bg-[#2563EB] rounded-full opacity-40 animate-ping" style={{ animationDelay: "2.4s" }} />

        {/* Card */}
        <div className="relative z-10 w-full max-w-md">
          {/* Outer glow */}
          <div className="absolute -inset-1 bg-gradient-to-r from-[#22D3EE] via-[#2563EB] to-[#1D4ED8] rounded-3xl opacity-20 blur-xl animate-pulse" />
          <div className="absolute -inset-0.5 bg-gradient-to-r from-[#2563EB] to-[#1D4ED8] rounded-3xl opacity-25 blur-lg" />

          <div className="relative bg-gradient-to-br from-[#060E1C] via-[#080F1C] to-[#0B1E36] border border-[#2563EB]/35 rounded-3xl overflow-hidden shadow-2xl shadow-[#2563EB]/20">
            {/* Corner decorations */}
            <div className="absolute top-0 right-0 w-28 h-28 border-t-2 border-r-2 border-[#2563EB]/20 rounded-tr-3xl" />
            <div className="absolute bottom-0 left-0 w-20 h-20 border-b-2 border-l-2 border-[#2563EB]/15 rounded-bl-3xl" />
            {/* Left accent bar */}
            <div className="absolute left-0 top-0 bottom-0 w-1 bg-gradient-to-b from-[#22D3EE] via-[#2563EB] to-[#1D4ED8] animate-pulse" />
            {/* Top shimmer */}
            <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#2563EB]/50 to-transparent" />

            {/* ── HEADER ── */}
            <div className="px-6 pt-7 pb-5 border-b border-[#1e3a5f]/50">
              <div className="flex items-center gap-3 mb-1">
                <div onClick={() => navigate("/")} className="cursor-pointer flex items-center gap-2.5 group">
                  <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-[#22D3EE]/20 to-[#1D4ED8]/20 border border-[#2563EB]/40 flex items-center justify-center shadow-[0_0_16px_rgba(37,99,235,0.2)]">
                    <img src={logo} alt="logo" className="w-5 h-5 object-contain" />
                  </div>
                  <div className="leading-none">
                    <span className="text-sm font-extrabold text-[#f3f4f6] tracking-wide block">HEXAFUND</span>
                    <span className="text-[9px] text-[#2563EB] tracking-[0.2em] uppercase block mt-0.5">Crowd Funding</span>
                  </div>
                </div>
              </div>

              <div className="mt-4">
                <h2 className="text-xl font-black text-transparent bg-clip-text bg-gradient-to-r from-[#22D3EE] via-[#2563EB] to-[#1D4ED8]">
                  Fund Deposit
                </h2>
                <p className="text-[#475569] text-xs mt-0.5">Add USDT to your fund wallet via BEP-20</p>
              </div>
            </div>

            <div className="px-6 py-6 space-y-5">
              {/* Network info strip */}
              <div className="flex items-center gap-2 flex-wrap">
                {[
                  { label: "Network", value: "BNB Smart Chain" },
                  { label: "Token", value: "USDT · BEP-20" },
                ].map((chip) => (
                  <div key={chip.label} className="flex items-center gap-1.5 bg-[#071526]/80 border border-[#1e3a5f]/60 rounded-full px-3 py-1.5">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#22D3EE] flex-shrink-0" />
                    <span className="text-[#475569] text-[10px]">{chip.label}:</span>
                    <span className="text-[#7DD3FC] text-[10px] font-semibold">{chip.value}</span>
                  </div>
                ))}
              </div>

              {/* Info box */}
              <div className="flex items-start gap-3 rounded-xl p-4 border border-[#2563EB]/20"
                style={{ background: "linear-gradient(135deg, rgba(37,99,235,0.08) 0%, rgba(29,78,216,0.04) 100%)" }}>
                <div className="w-8 h-8 rounded-lg bg-[#2563EB]/15 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <svg className="w-4 h-4 text-[#2563EB]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <div>
                  <p className="text-[#7DD3FC] text-xs font-semibold mb-0.5">How it works</p>
                  <p className="text-[#475569] text-xs leading-relaxed">
                    Enter the amount, generate a QR code, send USDT (BEP-20) to the address, then submit.
                  </p>
                </div>
              </div>

              {/* Amount input */}
              <div>
                <label className="flex items-center gap-2 text-[#94A3B8] text-xs font-semibold uppercase tracking-widest mb-2">
                  <svg className="w-3.5 h-3.5 text-[#2563EB]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
                  </svg>
                  Deposit Amount
                </label>
                <div className="relative group">
                  <input
                    placeholder="0.00"
                    id="inr_value"
                    name="inr_value"
                    type="number"
                    value={fk.values.inr_value}
                    onChange={fk.handleChange}
                    className="w-full pl-4 pr-16 py-4 rounded-2xl bg-[#071526]/80 border border-[#1e3a5f]/60 text-white text-lg font-bold placeholder-[#334155] focus:outline-none focus:border-[#2563EB]/70 focus:ring-1 focus:ring-[#2563EB]/30 transition-all duration-200"
                  />
                  <div className="absolute right-4 top-1/2 -translate-y-1/2 flex items-center gap-1.5 pointer-events-none">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#22D3EE]" />
                    <span className="text-[#22D3EE] text-xs font-bold tracking-wider">USDT</span>
                  </div>
                  {/* Focus glow */}
                  <div className="absolute -inset-px rounded-2xl bg-gradient-to-r from-[#22D3EE]/20 to-[#2563EB]/20 opacity-0 group-focus-within:opacity-100 blur-sm pointer-events-none transition-opacity duration-300" />
                </div>
              </div>

              {/* Generate QR Button */}
              <button
                onClick={() => areYouSureFn(Swal, generateDepositQrCode)}
                className="relative w-full py-4 rounded-2xl font-bold text-sm overflow-hidden group transition-all duration-300 hover:scale-[1.02] active:scale-[0.98]"
              >
                <div className="absolute inset-0 bg-gradient-to-r from-[#1D4ED8] via-[#2563EB] to-[#22D3EE]" />
                <div className="absolute inset-0 bg-gradient-to-br from-[#22D3EE] via-[#2563EB] to-[#1D4ED8] opacity-0 group-hover:opacity-90 transition-opacity duration-400" />
                <div className="absolute -inset-1 bg-gradient-to-r from-[#22D3EE] to-[#2563EB] opacity-0 group-hover:opacity-60 blur-xl rounded-2xl transition-opacity duration-400" />
                {/* Shine */}
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none">
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/25 to-transparent -skew-x-12 translate-x-[-200%] group-hover:translate-x-[200%] transition-transform duration-800" />
                </div>
                <span className="relative z-10 flex items-center justify-center gap-2.5 text-white">
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M12 15h4.01M12 21h4.01M12 18h4.01M12 9h4.01M12 6h4.01M6 3h12a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V5a2 2 0 012-2z" />
                  </svg>
                  Generate QR Code
                </span>
              </button>

              {/* QR Code Display */}
              {qrCode && (
                <div className="rounded-2xl border border-[#2563EB]/25 overflow-hidden"
                  style={{ background: "linear-gradient(135deg, rgba(37,99,235,0.06) 0%, rgba(6,14,28,1) 100%)" }}>
                  {/* QR header */}
                  <div className="flex items-center gap-2 px-4 py-3 border-b border-[#1e3a5f]/50">
                    <div className="w-2 h-2 rounded-full bg-[#22D3EE] animate-pulse" />
                    <span className="text-[#7DD3FC] text-xs font-semibold uppercase tracking-widest">Payment QR</span>
                    <span className="ml-auto text-[10px] text-[#475569] bg-[#071526]/60 border border-[#1e3a5f]/40 rounded-full px-2 py-0.5">
                      ${fk.values.inr_value} USDT
                    </span>
                  </div>

                  {/* QR body */}
                  <div className="px-4 py-5 flex flex-col items-center gap-4">
                    {/* QR frame */}
                    <div className="relative p-3 rounded-2xl bg-white shadow-[0_0_30px_rgba(37,99,235,0.3)]">
                      <div className="absolute inset-0 rounded-2xl ring-1 ring-[#2563EB]/40" />
                      <img src={qrCode?.qr} alt="QR Code" className="w-40 h-40 block" />
                    </div>

                    {/* Address */}
                    <div className="w-full rounded-xl p-3 border border-[#1e3a5f]/60 bg-[#071526]/60">
                      <p className="text-[#475569] text-[10px] uppercase tracking-widest mb-1.5">Wallet Address</p>
                      <p className="text-[#7DD3FC] text-xs font-mono break-all leading-relaxed">{qrCode?.address}</p>
                    </div>

                    {/* Copy button */}
                    <button
                      onClick={() => { navigator.clipboard.writeText(qrCode?.address || ""); toast.success("Address copied!"); }}
                      className="w-full py-2.5 rounded-xl text-xs font-bold text-white border border-[#2563EB]/30 hover:border-[#2563EB]/60 hover:bg-[#2563EB]/15 transition-all duration-200 flex items-center justify-center gap-2"
                    >
                      <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                      </svg>
                      Copy Address
                    </button>
                  </div>
                </div>
              )}

              {/* Submit Button */}
              <button
                onClick={sendTokenTransaction}
                className="relative w-full py-4 rounded-2xl font-bold text-sm overflow-hidden group transition-all duration-300 hover:scale-[1.02] active:scale-[0.98]"
              >
                <div className="absolute inset-0 bg-gradient-to-r from-[#1D4ED8] via-[#2563EB] to-[#22D3EE]" />
                <div className="absolute inset-0 bg-gradient-to-br from-[#22D3EE] via-[#2563EB] to-[#1D4ED8] opacity-0 group-hover:opacity-90 transition-opacity duration-400" />
                <div className="absolute -inset-1 bg-gradient-to-r from-[#22D3EE] to-[#2563EB] opacity-0 group-hover:opacity-60 blur-xl rounded-2xl transition-opacity duration-400" />
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none">
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/25 to-transparent -skew-x-12 translate-x-[-200%] group-hover:translate-x-[200%] transition-transform duration-800" />
                </div>
                <span className="relative z-10 flex items-center justify-center gap-2.5 text-white">
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  Submit Transaction
                  <svg className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </span>
              </button>

              {/* Back link */}
              <div className="text-center">
                <button onClick={() => navigate(-1)}
                  className="text-xs text-[#475569] hover:text-[#7DD3FC] transition-colors duration-200 flex items-center gap-1.5 mx-auto">
                  <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                  </svg>
                  Go Back
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TopupWithContWithoutPull;
